export const CRM_ROUTE = {
    'home': 'dashboard',
    "leadsOverview": "leads-overview",
    "pipelineProcessing": "pipeline-processing",
    "performanceOverview": "performance-overview",
    "customerInsight": "customer-insight",
    "daftarAO": "daftar-account-officer",
    "customer": "customer",
    "usaha": "usaha",
    "log": "log",
    "role": "role",





    'principal': "principal",
    'jaminan': 'jaminan',
    "kantor-pusat": "kantor-pusat",
    "kantor-cabang": "kantor-cabang",
    "nasabah": "nasabah",
    "management": "management",
    "kontrakBaru": "kontrak-baru",
    "kontrakAktif": "kontrak-aktif",
    "kontrakJatuhTempo": "kontrak-jatuh-tempo",
    "kontrakLunas": "kontrak-lunas",
    "kontrakPeminjaman": "kontrak-peminjaman", //Kredit
    "pengajuanDanaPrincipal": "pengajuan-dana-principal",
    "pencairanDanaPrincipal": "pencairan-dana-principal",
    "pembayaranNasabah": "pembayaran-nasabah",
    "pembayaranPrincipal": "pembayaran-principal",
    "pencairanDanaNasabah": "pencairan-dana-nasabah",
    "pencairanNasabah": "pencairan-nasabah",
    "mutasiRekening": "mutasi-rekening",
    "mutasiKas": "mutasi-kas",
    "report": "report",
    "chartOfAccounts": "daftar-akun",
    "asset": "asset",
    "assetDepreciation": "depresiasi-aset",
    "biayaLainnya": "biaya-lainnya",
    "pendapatanLainnya": "pendapatan-lainnya",
    "admin": "admin",
    "komponenAdministrasi": "komponen-administrasi"
}